var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 47.5C12.5736 47.5 2.5 37.4265 2.5 25C2.5 12.5736 12.5736 2.5 25 2.5",
    stroke: "#FED5F2",
    strokeWidth: 3.6,
    strokeLinecap: "round",
    strokeDasharray: "6 7.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 2.5C37.4265 2.5 47.5 12.5736 47.5 25C47.5 37.4265 37.4265 47.5 25 47.5",
    stroke: "#572148",
    strokeWidth: 3.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 35V16.25",
    stroke: "#572148",
    strokeWidth: 3.6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 25L25 16.25L16.25 25",
    stroke: "#572148",
    strokeWidth: 3.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.31b44efbf7124cd729efb44f9a463129.svg";
export { ForwardRef as ReactComponent };